import React from "react";
import PropTypes from "prop-types";

const TopToolbar = ({ containerId, mobileResponsiveUtil, children }) => {
  return (
    <>
      <div className="top-toolbar">{children}</div>
      <style jsx="true">
        {`
          #${containerId} .top-toolbar {
            top: ${mobileResponsiveUtil.getHeightValue(
              66 * 0.6494845361
            )}px !important;
            left: ${mobileResponsiveUtil.getWidthValue(75)}px !important;
            position: absolute !important;
            z-index: 1 !important;
            display: flex !important;
            flex-direction: column !important;
          }
        `}
      </style>
    </>
  );
};

TopToolbar.propTypes = {
  containerId: PropTypes.string.isRequired,
  mobileResponsiveUtil: PropTypes.shape({
    getHeightValue: PropTypes.func,
    getWidthValue: PropTypes.func,
    getFontSize: PropTypes.func,
  }),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

TopToolbar.defaultProps = {
  mobileResponsiveUtil: {
    getHeightValue: () => {},
    getWidthValue: () => {},
    getFontSize: () => {},
  },
};

export default TopToolbar;
